import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import { clientActions } from "../../sagas/clientSlice";
import * as Yup from 'yup';
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import './DisplayClient.css';

const initForm = {
    firstName: '',
    lastName: '',
    email: '',
    gender: '',
    phoneNbr: '',
    cinExpirationDate: '',
    cinNbr: '',
    city: '',
    ice: '',
    type: 'particulier',
    businessName: '',
    adresse: '',
    companyId: '',
    nationalite: ''
};
const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    gender: Yup.string().required('Gender is required'),
    phoneNbr: Yup.string().required('Phone number is required'),
    cinExpirationDate: Yup.date().required('CIN expiration date is required'),
    cinNbr: Yup.string().required('CIN number is required'),
    city: Yup.string().required('City is required'),
    ice: Yup.string().required('ICE is required'),
    type: Yup.string().required('Type is required'),
    businessName: Yup.string().required('Business name is required'),
    adresse: Yup.string().required('Address is required'),
    companyId: Yup.number().required('Company ID is required'),
    nationalite: Yup.string().required('Nationality is required')
});

const ClientForm = ({onClientAdded, onClose}) => {

    const { t } = useTranslation('translation');
    const dispatch = useDispatch();

    

    const onSubmit = (values, { setSubmitting }) => {
        debugger
        let payload = {
            data:{...values},
            onSuccess: (data) => {
                setSubmitting(false);
                onClientAdded(data);
                 Swal.fire({
                    icon: 'success',
                    title: t('common.saved'),
                    text: t('devis.client.savedSuccess'),
                });  

            },
        }
        dispatch(clientActions.addClient(payload));
    };

    return (
        <Container fluid>
            <Formik
                initialValues={initForm}
                //validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({ isSubmitting, handleChange,handleSubmit, setFieldValue, getFieldProps, values = {} }) => (
                    <Form>
                        <div className="form-group">
                            <label>Type:</label>
                            <div className="radio-group">
                                <label>
                                    <input
                                        type="radio"
                                        name="type"
                                        value="particulier"
                                        checked={values.type === 'particulier'}
                                        onChange={handleChange}
                                    />
                                    Particulier
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="type"
                                        value="entreprise"
                                        checked={values.type === 'entreprise'}
                                        onChange={handleChange}
                                    />
                                    Entreprise
                                </label>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group half-width">
                                <label htmlFor="firstName">{t('devis.client.firstName')}:</label>
                                <input type="text" id="firstName" name="firstName" onChange={handleChange} required />
                            </div>
                            <div className="form-group half-width">
                                <label htmlFor="lastName">{t('devis.client.lastName')}:</label>
                                <input type="text" id="lastName" name="lastName" onChange={handleChange} required />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group half-width">
                                <label htmlFor="email">{t('devis.client.email')}:</label>
                                <input type="email" id="email" name="email" onChange={handleChange} required />
                            </div>
                            <div className="form-group half-width">
                                <label htmlFor="gender">{t('devis.client.gender')}:</label>
                                <input type="text" id="gender" name="gender" onChange={handleChange} required />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group half-width">
                                <label htmlFor="cinNbr">{t('devis.client.cinNbr')}:</label>
                                <input type="text" id="cinNbr" name="cinNbr" onChange={handleChange} required />
                            </div>
                            <div className="form-group half-width">
                                <label htmlFor="cinExpirationDate">{t('devis.client.cinExpirationDate')}:</label>
                                <input type="date" id="cinExpirationDate" name="cinExpirationDate" onChange={handleChange} required />
                            </div>
                        </div>
                        <div className="form-row">
                        <div className="form-group half-width">
                                <label htmlFor="phoneNbr">{t('devis.client.phoneNbr')}:</label>
                                <input type="text" id="phoneNbr" name="phoneNbr" onChange={handleChange} required />
                            </div>
                            <div className="form-group half-width">
                                <label htmlFor="city">{t('devis.client.city')}:</label>
                                <input type="text" id="city" name="city" onChange={handleChange} required />
                            </div>
                        </div>
                        <div className="form-row">
                        <div className="form-group half-width">
                                <label htmlFor="adresse">{t('devis.client.adresse')}</label>
                                <input type="text" id="adresse" name="adresse" onChange={handleChange} required />
                            </div>
                         
                        </div>
                        {values.type === 'entreprise' && (
                            <>
                                <div className="form-row">
                                    <div className="form-group half-width">
                                        <label htmlFor="businessName">{t('devis.client.businessName')}:</label>
                                        <input type="text" id="businessName" name="businessName" onChange={handleChange} required />
                                    </div>
                                    <div className="form-group half-width">
                                        <label htmlFor="ice">{t('devis.client.ice')}:</label>
                                        <input type="text" id="ice" name="ice" onChange={handleChange} required />
                                    </div>
                                </div>
                            </>
                        )}

                        <Row className="mt-3">
                            <Col md={12} className="text-right">
                                <Button type="submit" color="primary" >
                                    {t('common.save')}
                                </Button>
                                <Button type="button" color="secondary" onClick={onClose} className="ml-2">
                                    {t('common.cancel')}
                                </Button>
                            </Col>
                        </Row>

                    </Form>
                )}
            </Formik>
        </Container>
    );
};

export default ClientForm;